import { Button } from "@mui/material";
import { Col, Modal, Row } from "antd";

export function ModalConfirmMail({
  action,
  closeFn,
  visible,
}: {
  action: (sendMail: boolean) => void;
  visible: boolean;
  closeFn: () => void;
}) {
  function handleClick(send: boolean) {
    action(send);
    closeFn();
  }

  return (
    <Modal
      title="Enviar por e-mail"
      visible={visible}
      onCancel={() => closeFn()}
      closable={true}
      footer={
        <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
          <Col xs={24} sm={12}>
            <Button
              fullWidth
              size="large"
              color="primary"
              variant="contained"
              onClick={() => {
                handleClick(true);
              }}>
              Sim
            </Button>
          </Col>
          <Col xs={24} sm={12}>
            <Button
              fullWidth
              size="large"
              color="primary"
              variant="contained"
              onClick={() => {
                handleClick(false);
              }}>
              Não
            </Button>
          </Col>
        </Row>
      }>
      <Row>
        <Col>Gostaria de receber o documento também por e-mail?</Col>
      </Row>
    </Modal>
  );
}
